import { render, staticRenderFns } from "./UserRecordDialog.vue?vue&type=template&id=784adae7&scoped=true&"
import script from "./UserRecordDialog.vue?vue&type=script&lang=js&"
export * from "./UserRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784adae7",
  null
  
)

export default component.exports